import { apiRequest } from '../config/axios/axios'

export const fetchTVChannels = (platform) => {
  return apiRequest(`/channels?platform=${platform}`)
}
